import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import Avatar from '../AvatarComponent/AvatarComponent'

import './WebinarUserInfoPaneComponent.scss'

const WebinarUserInfoPaneComponent = ({ name, children, avatarUrl }) => (
  <div className="webinar-user-info-pane">
    <div className="webinar-user-info-pane-background">
      {!!name && (
        <div className="webinar-user-info-pane-avatar">
          <Avatar imageSrc={avatarUrl} name={name} size={65} shape="square" />
        </div>
      )}
      <p className="webinar-user-info-pane-title">
        {name ? (
          <FormattedMessage
            defaultMessage="Welcome {name}!"
            values={{ name }}
          />
        ) : (
          <FormattedMessage defaultMessage="Welcome!" />
        )}
      </p>
      {children}
    </div>
  </div>
)

WebinarUserInfoPaneComponent.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  avatarUrl: PropTypes.string,
}

// eslint-disable-next-line import-x/no-default-export
export default WebinarUserInfoPaneComponent
